export const CHANGE_COLLAPSIBLE = 'Content/CHANGE_COLLAPSIBLE'

export const changeCollapsible = collapsibleName => ({
    type: CHANGE_COLLAPSIBLE,
    payload: collapsibleName
})
